/* app/page/all */

define(
	'app/page/all',[
		'jquery',
		'util/lazyload',
		'app/ui/nav/load',
		'app/ui/track/load',
		'app/ui/rotator/rotator',
		'app/ui/expand-collapse/expand-collapse',
		'app/ui/video/video.player',
		'app/ui/social/share',
		'app/ui/map/map.load',
		'app/ui/form/form.umbraco',
		'app/ui/tooltip/tooltip',
		'app/ui/ajaxreplace/ajaxreplace',
		'app/ui/ticker/ticker',
		'app/ui/cookie/cookie',
		'moment',
		'pikaday',

		'util/core',

		'phatfingaz',
		'pubsub',
		'throttledebounce',
		'appendaround'
	],
	function ($, LazyLoad, NavLoad, TrackLoad, Rotator, ExpandCollapse, VideoPlayer, SocialShare, MapLoad, UmbracoForms, Tooltip, AjaxReplace, Ticker, Cookie, moment, Pikaday, Util) {

		'use strict';

		var $window = $(window);

		TrackLoad.init();
		NavLoad.init();
		LazyLoad.init();
		Tooltip.init();
		AjaxReplace.init();
		SocialShare.init();
		Cookie.init();

		// Publish Resize event
		var publishResizeEvent = function () {
			$.publish('/window/resize');
		};

		var publishScrollEvent = function () {
			$.publish('/window/scroll');
		};

		$('.js-hot').phatFingaz();

		// ExpandCollapse
		ExpandCollapse.init();

		// Video Macros
		VideoPlayer.init();

		// Umbraco Forms
		// init function will load required dependencies if an umbraco form is present
		UmbracoForms.init();

		// Maps
		var $maps = $('.js-map');
		if ($maps.length) {
			MapLoad.init($maps);
		}

		// Rotators
		var $rotators = $('.js-rotator');
		if ($rotators.length) {
			Rotator.init($rotators);
		}

		// Ticker
		var $ticker = $('.js-statistics');
		if($ticker.length) {
			Ticker.init();
		}

		$window.on('resize', $.throttle(250, publishResizeEvent));
		$window.on('scroll', publishScrollEvent);

		var $datepickers = $('.js-datepicker');
		if ($datepickers.length) {
			$datepickers.each(function () {
				var $datepicker = $(this);

				if ($('.touchevents').length) {
					$datepicker.attr('readonly', 'readonly');
				}
				new Pikaday({ field: this, yearRange: 10 });
			});
		}

		// Language Dropdown
		var languagePicker = $('#language_chooser');
		var languageRedirect = function() {
			window.location.href = this.value;
		};

		languagePicker.appendAround();
		languagePicker.on('change', languageRedirect);

		$('.js-smooth-scroll-anchor').on('click', function (e) {
			var $link = $(e.target);
			var $target = $($link.attr('href'));

			if ($target.length) {
				Util.scrollToElm($target);
			}
		});
	}
);
